import * as THREE from 'three'

const canvas = document.querySelector('canvas.webgl')
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { OutlinePass } from "three/examples/jsm/postprocessing/OutlinePass";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { EffectComposer } from "three/examples/jsm/postprocessing/EffectComposer";
import { RenderPass } from "three/examples/jsm/postprocessing/RenderPass";
import { GammaCorrectionShader } from 'three/examples/jsm/shaders/GammaCorrectionShader.js'
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass.js'
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader.js'
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry.js'
import { RoundedBoxGeometry } from 'three/addons/geometries/RoundedBoxGeometry.js';



//media property
const MediaQuery = window.matchMedia("(max-width: 700px)")

/**
 * LOader
 */


let run_anime = false
const loadingBar = document.querySelector('.loading')
const loadingBack = document.querySelector('.loadingback')
let css_of_after = window.getComputedStyle(loadingBar, '::before')

const loadingManager = new THREE.LoadingManager( 
        // Loaded
        () =>
        {
            window.setTimeout(()=>{
            loadingBar.style.visibility = 'hidden'
            loadingBack.style.visibility = 'hidden'
            run_anime = true}, 1000)
        },
    
        // Progress
        (itemUrl, itemsLoaded, itemsTotal) =>
        {
            const progressRatio = 100 * itemsLoaded / itemsTotal + '%'
            console.log(progressRatio)
            loadingBar.style.setProperty('--len',  progressRatio);
        }
)

//texture loader
const textureloader = new THREE.TextureLoader(loadingManager)

/**
 * Scroll
 */
let scrollY = window.scrollY

window.addEventListener('scroll', () =>
{
    scrollY = window.scrollY

    //console.log(scrollY)
})


/**
 * Raycaster
 */
const raycaster = new THREE.Raycaster()


/**
 * mouse move 
 */

const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) =>
{
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1
})

window.addEventListener('click', () =>
{
    if(currentIntersect)
    {
        switch(currentIntersect.object)
        {
            case about_banner:
                window.location.href = "about.html";
                break

            case banner:
                window.location.href = "skills.html";
                break

            case contact_banner:
                window.location.href = "contact.html"
                break
            case project_banner:
                window.location.href = "projects.html"
                break
        }
    }
})

/** 
 * Scene
*/ 
var Smaterial = new THREE.ShaderMaterial({
    uniforms: {
      color1: {
        value: new THREE.Color("white")
      },
      color2: {
        value: new THREE.Color("rgb(239, 245, 158)") //rgb(239, 245, 158)
      }
    },
    vertexShader: `
      varying vec2 vUv;
  
      void main() {
        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0);
      }
    `,
    fragmentShader: `
      uniform vec3 color1;
      uniform vec3 color2;
    
      varying vec2 vUv;
      
      void main() {
        
        gl_FragColor = vec4(mix(color1, color2, vUv.y), 1.0);
      }
    `,
    //wireframe: true
  });
const scene = new THREE.Scene()
const sun = textureloader.load('/textures/sun1.png')
sun.offset.set(0,0)
scene.background =  sun //#e3e3e3 #d7f7f5


/**
 * font and text
 */
const fontLoader = new FontLoader()

fontLoader.load(
    '/fonts/helvetiker_regular.typeface.json',
    (font) =>
    {
        const text_properties = {font: font,
            size: 1.0,
            height: 0.5,
            curveSegments: 5,
            bevelEnabled: true,
            bevelThickness: 0.03,
            bevelSize: 0.07,
            bevelOffset: 0,
            bevelSegments: 4
        }
        const textGeometry = new TextGeometry(
            'C++', text_properties)
        const textMaterial = new THREE.MeshStandardMaterial({ color: 'white' })
        textMaterial.wireframe = false
        const text = new THREE.Mesh(textGeometry, textMaterial)
        text.position.y = 9.5
        text.rotation.y = - Math.PI * 0.2
        text.rotation.z =  Math.PI * 0.1
        text.position.z = -7.7
        text.position.x = 9.5
        const jstxt = text.clone()
        const textGeometryjs = new TextGeometry(
            'js', text_properties)
            jstxt.material = new THREE.MeshStandardMaterial({ color: 'white' });
        jstxt.geometry = textGeometryjs
        jstxt.position.y = 7.5
        jstxt.position.x = 10
        jstxt.rotation.z = - Math.PI * 0.1 
        scene.add(jstxt)    
        scene.add(text)
        console.log('loaded')
    }
)



/**
 * textures
 */


const skilltexture = textureloader.load('/textures/skills.png',
() =>{
    console.log('load')
},
() =>{
    console.log('progress')
},
() =>{
    console.log('error')
})
const abouttexture = textureloader.load('/textures/about.jpg',
() =>{
    console.log('load')
},
() =>{
    console.log('progress')
},
() =>{
    console.log('error')
})
const projecttexture = textureloader.load('/textures/projectImg.png',
() =>{
    console.log('load')
},
() =>{
    console.log('progress')
},
() =>{
    console.log('error')
})
const contacttexture = textureloader.load('/textures/Contact.png',
    () =>{
        console.log('load')
    },
    () =>{
        console.log('progress')
    },
    () =>{
        console.log('error')
    })
projecttexture.colorSpace = THREE.SRGBColorSpace
abouttexture.colorSpace = THREE.SRGBColorSpace
skilltexture.colorSpace = THREE.SRGBColorSpace
contacttexture.colorSpace = THREE.SRGBColorSpace

/**
 * Lights
 */

const light = new THREE.AmbientLight( 0x404040, 40); // soft white light 50 40
scene.add( light );

const directionalLight = new THREE.DirectionalLight(0xffff99, 2) //0xffff99
directionalLight.position.set(-1.5, 0.75, 0)  //-1, 0.25, 0 -1.5, 0.75, 0
scene.add(directionalLight)
const d = 30
directionalLight.castShadow = true
directionalLight.shadow.camera.left = - d;
directionalLight.shadow.camera.right = d;
directionalLight.shadow.camera.top = d;
directionalLight.shadow.camera.bottom = - d;
directionalLight.shadow.camera.near = -30;
directionalLight.shadow.camera.far = 40;
directionalLight.shadow.mapSize.width = 1024
directionalLight.shadow.mapSize.height = 1024
//const directionalLightCameraHelper = new THREE.CameraHelper(directionalLight.shadow.camera)
//scene.add(directionalLightCameraHelper)


/**
 * PArticles
 */
const particlesGeometry = new THREE.BufferGeometry()
const count = 500
const particlesMaterial = new THREE.PointsMaterial({
    size: 0.1,
    sizeAttenuation: true
})
particlesMaterial.color = new THREE.Color('#ff88cc')
const positions = new Float32Array(count * 3) // Multiply by 3 because each position is composed of 3 values (x, y, z)

for(let i = 0; i < count; i++) // Multiply by 3 for same reason
{
   // let i3 =  i * 3
    positions[i] = (Math.random() - 0.5) * 50
// postion of particles along x axis
    
}
particlesGeometry.setAttribute('position', new THREE.BufferAttribute(positions, 3))

const particles = new THREE.Points(particlesGeometry, particlesMaterial)
scene.add(particles)



/**
 * Object
 */
//var geometry = new THREE.CylinderBufferGeometry(2, 5, 20, 32, 1, true);

//road
const geometryc = new THREE.BoxGeometry(1, 1, 1, 2, 2, 2)
const materialc = new THREE.MeshStandardMaterial()
materialc.color.set('grey')
const road = new THREE.Mesh(geometryc, materialc)
road.position.y = 0.1
road.position.z = 17
road.scale.z = 200
road.scale.x = 10
road.receiveShadow = true
scene.add(road)

//strips on road
const materialstrip = new THREE.MeshBasicMaterial({ color: '#e5d663' })
const strips = new THREE.Mesh(geometryc,materialstrip)
strips.position.y = 0.2
strips.position.z = 17
strips.scale.z = 200
strips.scale.x = 0.3
scene.add(strips)

const Strip2 = strips.clone()
Strip2.position.x = 0.4
scene.add(Strip2)

//plane ground
const geometry = new THREE.PlaneGeometry( 200, 100 ); //100 200 rgb(239, 232, 158)
const material = new THREE.MeshStandardMaterial({color : "white"})
material.roughness = 0.7
const plane = new THREE.Mesh( geometry, Smaterial );
plane.rotation.x = - Math.PI * 0.5
plane.position.y = 0
plane.position.z = - 30
plane.receiveShadow = true
scene.add( plane );

//billnoard banner
const materialskill = new THREE.MeshStandardMaterial()
materialskill.map = skilltexture
const banner = new THREE.Mesh(new THREE.PlaneGeometry(8, 4), materialskill)
banner.position.y = 9.2
banner.position.x = 8.7
banner.position.z = -8.2
banner.rotation.y = - Math.PI * 0.2

//bammer contact me
const materialContact = new THREE.MeshStandardMaterial()
const contact_banner = banner.clone()
materialContact.map = contacttexture
contact_banner.material = materialContact
contact_banner.position.z = -28.2
scene.add(contact_banner)

//banner projects
const materialproject = new THREE.MeshStandardMaterial()
materialproject.map = projecttexture
const project_banner = banner.clone()
project_banner.material = materialproject
project_banner.position.x = -8.7
project_banner.position.z = -18.2
project_banner.rotation.y =  Math.PI * 0.2
scene.add(project_banner)

//about
const materialabout = new THREE.MeshStandardMaterial()
materialabout.map = abouttexture
const about_banner = project_banner.clone()
about_banner.material = materialabout
about_banner.position.z = 11.8
scene.add(about_banner)

//shadow text

/*
* SHADOWS
*/

const circleShadow = textureloader.load('/textures/simpleShadow.jpg')

const simpleShadow = textureloader.load('/textures/treeShadow.png')
const billboardShadow1 = new THREE.Mesh(
    new THREE.PlaneGeometry(7, 7),
    new THREE.MeshBasicMaterial({
        //color: "#000000",
        transparent: true,
        map: simpleShadow
        //alphaMap: circleShadow
    })
)
billboardShadow1.position.x = -8.7
billboardShadow1.position.z = 10
billboardShadow1.rotation.x = - Math.PI * 0.5
billboardShadow1.position.y = plane.position.y + 0.02
billboardShadow1.material.opacity = 0.5

const billboardShadow2 = billboardShadow1.clone()
billboardShadow2.position.z = -20

const billboardShadow3 = billboardShadow1.clone()
billboardShadow3.position.z = -10
billboardShadow3.position.x = 11.7

const billboardShadow4 = billboardShadow3.clone()
billboardShadow4.position.z = -30
scene.add(billboardShadow1,billboardShadow2, billboardShadow3, billboardShadow4)


//trees
const tree_geometry = new THREE.CylinderGeometry( 0.5, 0.5, 3, 32 ); 
const tree_material = new THREE.MeshStandardMaterial( {color: 'rgb(224, 182, 149)'} ); 
const leaves_geometry = new RoundedBoxGeometry( 2, 4, 2 , 25 , 0.5); 
const leaves_material = new THREE.MeshStandardMaterial( {color: "rgb(239, 245, 158)"} );  //#00b300
leaves_material.opacity = 0.3
const leaves2_geometry = new RoundedBoxGeometry( 1.5, 1.8, 1.5, 15, 0.3); 
const leaves3_geometry = new RoundedBoxGeometry( 1.5, 3, 1.5, 25, 0.5);
const stem1_geometry = new THREE.BoxGeometry(2.5 , 0.5 , 0.5)
const forest = new THREE.Group()

// tree.position.y = 1.5
// tree.position.x = 15
for(let x = 0; x < 20 ; x++ ){ //11 20
    const x1 = 11 + Math.random() * 30
    const x2 = -(11 + Math.random() * 30) //10
    const z = - ( -20 + Math.random() * 90) //10 30 40 //thhink it again
    const bark = new THREE.Mesh( tree_geometry, tree_material );
    const leaves = new THREE.Mesh( leaves_geometry,leaves_material );
    leaves.position.y = 3
    const leaves2 = new THREE.Mesh( leaves2_geometry, leaves_material );
    leaves2.position.y = 5 //5
    const leaves3 = new THREE.Mesh( leaves3_geometry, leaves_material );
    leaves3.position.x = 2
    leaves3.position.y = 3
    const stem1 = new THREE.Mesh( stem1_geometry, tree_material );
    stem1.position.y = 0.3
    stem1.position.x = 1
    const stem2 = new THREE.Mesh( stem1_geometry, tree_material );
    stem2.position.y = 1.3
    stem2.position.x = 2
    stem2.rotation.z = Math.PI*0.5 
    //tree shadow
    const treeShadow = new THREE.Mesh(
        new THREE.PlaneGeometry(5, 4),
        new THREE.MeshBasicMaterial({
            color: "#000000",
            transparent: true,
            map: simpleShadow
            //alphaMap: circleShadow
        })
    )
    //treeShadow.position.z = bark.position.z + 1
    treeShadow.material.opacity = 0.3
    //treeShadow.position.x = bark.position.x + 1
    treeShadow.rotation.x = - Math.PI * 0.5
    treeShadow.position.x = 0.8
    //tree group
    const tree = new THREE.Group()
    //tree.position.y = 2.3
    tree.add( bark );
    tree.add( leaves );
    tree.add(leaves2)
    tree.add(leaves3, stem1,stem2)

    //shadow added to the trees 
    const tree_with_shadow = new THREE.Group()
    const tree_with_shadow2 = new THREE.Group()
    tree_with_shadow.add(tree)
    tree_with_shadow.add(treeShadow)
    //tree.add(treeShadow)
    //scene.add(tree)
    const tree2 = tree.clone()
    const shadow2 = treeShadow.clone()
    
    tree_with_shadow2.add(tree2,shadow2)
    tree2.position.set(x2,1.5,z)
    tree.position.set(x1,1.5,z)
    treeShadow.position.set(x1 + 0.8,plane.position.y+0.01,z)
    shadow2.position.set(x2 + 0.8,plane.position.y+0.01,z)
    tree.rotation.y = (Math.random() - 0.5) * 2
    tree2.rotation.y = (Math.random() - 0.5) * 1
    //treeShadow.rotation.y = 0 
    forest.add(tree_with_shadow)
    forest.add(tree_with_shadow2)
}
scene.add(forest)



//bark.position.y = 5

scene.add(banner)


/**
 * export 3d ojects
 */

const gltfLoader = new GLTFLoader(loadingManager)
//kei truck

let keitruck;
gltfLoader.load(
    '/models/kei4.glb', 
    (gltf) =>
    {
        console.log('success')
        //console.log(gltf)
        gltf.scene.position.x = 2
        gltf.scene.position.z = 17
        gltf.scene.position.y = -0.5 //-0.5 
        keitruck = gltf
        //console.log(keitruck) 
        gltf.scene.traverse (function (node){
            if(node instanceof THREE.Mesh){
                node.castShadow = true
                node.callback = gltf.scene
            }
            });   
        gltf.scene.rotation.y = - Math.PI * 0.5
        scene.add(gltf.scene)
    },
    (progress) =>
    {
        console.log('progress')
        console.log(progress)
    },
    (error) =>
    {
        console.log('error')
        console.log(error)
    }
)

//fox and the baby fox

let mixer = null
let mixer_baby = null
let fox = null
let baby_fox = null 
let baby_fox_2 = null

gltfLoader.load(
    '/models/Fox/glTF/Fox.gltf', 
    (gltf) =>
    {
        console.log('success')
        console.log(gltf)
        gltf.scene.position.x = 8
        gltf.scene.position.z = 5
        gltf.scene.position.y = 0 //-0.5 
        //gltf.scene.rotation.y =  - Math.PI 
        gltf.scene.scale.set(0.02,0.02,0.02)

        gltf.scene.traverse (function (node){
            if(node instanceof THREE.Mesh){
                node.castShadow = true
                node.callback = gltf.scene
            }
            }); 
        fox = gltf
        scene.add(gltf.scene)
        
        //animation
        mixer = new THREE.AnimationMixer(gltf.scene)
        const action = mixer.clipAction(gltf.animations[1])
        action.play()
    }
)
gltfLoader.load(
    '/models/Fox/glTF/Fox.gltf', 
    (gltf) =>
    {
        console.log('success')
        console.log(gltf)
        gltf.scene.position.x = 9
        gltf.scene.position.z = 5
        gltf.scene.position.y = 0 //-0.5 
        //gltf.scene.rotation.y =  - Math.PI 
        gltf.scene.scale.set(0.01,0.01,0.01)

        gltf.scene.traverse (function (node){
            if(node instanceof THREE.Mesh){
                node.castShadow = true
                node.callback = gltf.scene
            }
            }); 
        baby_fox = gltf
        scene.add(gltf.scene)
        //animation
        mixer_baby = new THREE.AnimationMixer(gltf.scene)
        const action = mixer_baby.clipAction(gltf.animations[2])
        action.play()
    }
)
//gaurd rail
gltfLoader.load(
    '/models/gaurdrail/scene.gltf', 
    (gltf) =>
    {
        console.log('success')
        console.log(gltf)
        gltf.scene.position.x = 6
        gltf.scene.position.z = 5
        gltf.scene.position.y = 0 //-0.5 
        gltf.scene.rotation.y = - Math.PI * 0.5
        
        gltf.scene.traverse (function (node){
            if(node instanceof THREE.Mesh){
                node.castShadow = true
                node.callback = gltf.scene
            }
            }); 
        scene.add(gltf.scene)

        //gaurdrail 2

        const gaurdrail2 = gltf.scene.clone()
        gaurdrail2.position.x = -6
        gaurdrail2.position.z = 8
        gaurdrail2.rotation.y = - Math.PI * 1.5
        scene.add(gaurdrail2)

        //garurdrail 3 left 
        const garurdrail3 = gaurdrail2.clone()
        garurdrail3.position.z = -8
        scene.add(garurdrail3)

        //gaurdrail4 right
        const gaurdrail4 = gltf.scene.clone()
        gaurdrail4.position.z = -8 
        scene.add(gaurdrail4)
    }
)

//road sign
gltfLoader.load(
    '/models/roadsign__cones_pack/scene.gltf', 
    (gltf) =>
    {
        console.log('success')
        console.log(gltf)
        gltf.scene.position.x = 2
        gltf.scene.position.z = -30
        gltf.scene.position.y = 0.7 //-0.5 
        //gltf.scene.rotation.y = - Math.PI * 0.5
        gltf.scene.scale.set(8,8,8)
        gltf.scene.traverse (function (node){
            if(node instanceof THREE.Mesh){
                node.castShadow = true
                node.callback = gltf.scene
            }
            }); 
        
        scene.add(gltf.scene)

    }
)

//billborad
gltfLoader.load(
    '/models/billboard.glb', 
    (gltf) =>
    {
        console.log('success')
        console.log(gltf)
        gltf.scene.position.x = -10
        gltf.scene.position.z = 10
        gltf.scene.position.y = -1 //-0.5      
        gltf.scene.rotation.y =  Math.PI * 0.2
        //gltf.scene.children[1].material.color.set('red')
        if(gltf.scene){ 
            //console.log(gltf.scene.children[1].material) 
            
        }
        scene.add(gltf.scene)
        
        //billboard 2
        const billboard2 = gltf.scene.clone()
        billboard2.position.x = 10
        billboard2.position.z = -10
        billboard2.rotation.y = - Math.PI * 0.2
        
        scene.add(billboard2)
        

        //billboard 3
        const billboard3 = gltf.scene.clone()
        billboard3.position.z = -20
        scene.add(billboard3)

        //billboard 4
        const billboard4 = gltf.scene.clone()
        billboard4.position.x = 10
        billboard4.position.z = -30
        billboard4.rotation.y = - Math.PI * 0.2
        scene.add(billboard4)
    })

    //scene.add(keitruck.scene)


    /**
 * Sizes
 */

const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

/**
 * Camera
 */

//base camera 
const camera = new THREE.PerspectiveCamera(70, sizes.width / sizes.height, 0.1, 50) //100 far
camera.position.x = 0
if(sizes.width < 768){
    camera.position.y = 28 
}
else{
    camera.position.y = 18
}
camera.position.z = 25  //25
camera.rotation.x =  - Math.PI * 0.2

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    
    composer.setSize(sizes.width, sizes.height)
    composer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

    //make camera responsive 
    if(sizes.width < 768){
        camera.position.y = 28 
    }
    else{
        camera.position.y = 18
    }
})




// Base camera

 //5



scene.add(camera)

//Controls

//const controls = new OrbitControls(camera, canvas)
//controls.enableDamping = true


/**
 * Renderer
 */

const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true

/**
 * Post-processing
 */
// const renderPass = new RenderPass( scene, camera );
var composer = new EffectComposer(renderer);
composer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
composer.setSize(sizes.width, sizes.height)
const renderPass = new RenderPass( scene, camera );
composer.addPass(renderPass)
const outlinePass= new OutlinePass(
    new THREE.Vector2(window.innerWidth, window.innerHeight), //resolution parameter
    scene,
    camera);
    outlinePass.edgeStrength = 5.0
    outlinePass.edgeGlow = 1.0
    outlinePass.edgeThickness = 1.0
outlinePass.visibleEdgeColor.set(0xe5d663);
outlinePass.hiddenEdgeColor.set(0x808080);
composer.addPass( outlinePass );
const gammaCorrectionPass = new ShaderPass(GammaCorrectionShader)
composer.addPass(gammaCorrectionPass)


/**
 * Animate
 */

const clock = new THREE.Clock()
let currentIntersect = null
let perviousTime = 0
const tick = () =>
{
    let elapsedTime = 0
    if(run_anime){
        elapsedTime = clock.getElapsedTime()
    }
    const deltaTime = elapsedTime - perviousTime
    perviousTime = elapsedTime

    
    // setting raycaster
    raycaster.setFromCamera(mouse, camera)
    const objectsToTest = [banner,project_banner,contact_banner,about_banner]
    let intersects = raycaster.intersectObjects(objectsToTest)
    if(intersects.length){
        if(!currentIntersect)
        {
            console.log('mouse enter')
        }

        currentIntersect = intersects[0]
        var selectedObject = intersects[0].object;
        outlinePass.selectedObjects = [selectedObject];
    }
    else{
        if(currentIntersect)
        {
            console.log('mouse leave')
        }
        
        currentIntersect = null
        outlinePass.selectedObjects.length = 0;
    }
    //console.log(intersects)
    //console.log(intersects.length)
    //console.log(intersects)
    
        
    //fox animation of foxes

    if(mixer)
    {
        mixer.update(deltaTime)
    }
    if(mixer_baby)
    {
        mixer_baby.update(deltaTime)
    }
    if(fox){
        fox.scene.position.z =  (elapsedTime * 2) - 30
    }   
    if(baby_fox){
        baby_fox.scene.position.z =  (elapsedTime * 1.8) - 33
    } 

    //Update controls
    //controls.update()

    //animate van and camera on scroll

    if(sizes.width > 768){
        camera.position.z = - scrollY / sizes.height * 2 + 25
        //plane.position.z = scrollY / sizes.height * 2
    }
    else{
    camera.position.z = - scrollY / sizes.height * 2 + 45
    //plane.position.z = scrollY / sizes.height * 2
    }
    //if screen size less than 700px
    if(keitruck){
        if(sizes.width > 768){
        keitruck.scene.position.z = - scrollY / sizes.height * 2.5 + 17 //2.5 17
        }
        else{
            keitruck.scene.position.z = - scrollY / sizes.height * 2.5 + 32 
        }
    }
    //console.log(camera.position.z)

    //animate particles 
    
    for(let i = 0; i < count; i++)
    {
        let i3 = i * 3
        const z = particlesGeometry.attributes.position.array[i3 + 2]
        const y = particlesGeometry.attributes.position.array[i3 + 1]
        const x = particlesGeometry.attributes.position.array[i3]
        particlesGeometry.attributes.position.array[i3+ 1] = Math.sin(elapsedTime + x) + 5
        particlesGeometry.attributes.position.array[i3] = (elapsedTime * ( Math.sin(z)))
        //particlesGeometry.attributes.position.array[i3+2] = Math.sin(elapsedTime) + 5
    }
    particlesGeometry.attributes.position.needsUpdate = true



    //Render
    //renderer.render(scene, camera)
    composer.render()

    //Call tick again on the next frame
    window.requestAnimationFrame(tick)
    //composer.render(scene, camera);
}

tick()